import { Component, EventEmitter, HostListener, Input, OnInit, Output } from "@angular/core";


/*
Usage:
<go4-modal>
  other content

  You can add extra buttons by using:
  <ng-container extra-buttons>
    // add as many as you need
    <button class="btn btn-custom">Extra Button</button>
    <button class="btn btn-custom">Extra Button2</button>
  </ng-container>
</go4-modal>
 */

@Component({
  selector: "go4-modal",
  templateUrl: "./go4-modal.component.html",
  styleUrls: ["./go4-modal.component.scss"]
})
export class Go4ModalComponent implements OnInit {

  @Input() title: string;

  @Input() draggable = false;

  @Input() loading: boolean;

  @Input() cancelButtonText: string;
  @Input() iconClassCancelButton = "fa-times";
  @Output() onCancel = new EventEmitter<void>();

  @Input() extraButtonIsExecuting = false;

  @Input() showExecuteButton = true;
  @Input() executeButtonIsDangerous = false;
  @Input() executeButtonText: string;
  @Input() iconClassExecuteButton = "fa-paper-plane";
  @Output() onExecute = new EventEmitter<void>();


  @HostListener("document:keydown", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key !== "Escape") {
      return;
    }

    this.onCancel.emit();
  }


  constructor() {
  }

  ngOnInit(): void {
  }
}
